import { screen } from '@/properties';
import { NotificationsResponse } from '@/api/dto/Notification';

/**
 * 通知のリンクを生成する
 * @param notification 通知
 * @returns
 */
export const notificationsLink = (notification: NotificationsResponse): string => {
  var targetScreen = screen.find(v => v.screenId == notification.screenId);
  if(targetScreen){
    if(targetScreen.isPram){
      var convertPath = targetScreen.path;
      var bindArray = targetScreen.bind.split(',') as ('dealId' | 'userId')[];
      for(var i=0; i<bindArray.length; i++){
        convertPath = convertPath.replace('*', notification[bindArray[i]]);
      }
      return convertPath;
    } else {
      return targetScreen.path;
    }
  } else {
    return '';
  }
};
